import React, { lazy } from 'react';
import { companyPagesMenu, componentPagesMenu, dashboardPagesMenu, demoPagesMenu, financeReportPageMenues, hrPagesMenu, hrProcessPagesMenu, marketingPagesMenu, myPages, pageLayoutTypesPagesMenu, pageMenues, productionPagesMenu, projectPagesMenu, purchasePagesMenu, purchasingPagesMenu, subProjectPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';
import Profile from '../pages/User/User';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};

const COMPANY = {
	POSITIONS: lazy(() => import('../pages/company/Positions')),
	DEPARTMENTS: lazy(() => import('../pages/company/Departments')),
	DETAILS: lazy(() => import("../pages/company/Details")),
	USERS: lazy(() => import('../pages/company/Users')),
	PEOPLE: lazy(() => import('../pages/company/PersonList')),
	PERSON: lazy(() => import('../pages/company/Person')),
	USER: lazy(() => import('../pages/company/User')),
};

const FINANCE = {
	ACCOUNTS: lazy(() => import("../pages/finance/Accounts")),
	TRANSACTIONS: lazy(() => import("../pages/finance/Transactions")),
	GENERAL: lazy(() => import("../pages/finance/GeneralReport")),
	INCOME: lazy(() => import("../pages/finance/Income")),
	OUTCOME: lazy(() => import("../pages/finance/Outcome"))

}

const COMPONENT = {
	MEASURES: lazy(() => import('../pages/components/Measures')),
	DEPARTMENTS: lazy(() => import('../pages/components/Departments')),
	DEPARTMENT: lazy(() => import('../pages/components/Department')),
	DEPARTMENT_SUBUNITS: lazy(() => import('../pages/components/Department/SubUnits')),
	DEPARTMENT_PEOPLE: lazy(() => import('../pages/components/Department/People')),
	DEPARTMENT_OPERATIONS: lazy(() => import('../pages/components/Department/Operations')),
	DEPARTMENT_GALLERY: lazy(() => import('../pages/components/Department/Gallery')),
	DEPARTMENT_TUTORIAL: lazy(() => import('../pages/components/Department/Tutorial')),


	RAWS: lazy(() => import('../pages/components/Raws')),
	RAW: lazy(() => import('../pages/components/Raw')),
	OPERATIONS: lazy(() => import('../pages/components/Operations')),
	OPERATION: lazy(() => import('../pages/components/Operation')),

	PARTNERS: lazy(() => import('../pages/components/Partners')),
	PARTNER: lazy(() => import('../pages/components/Partner')),

	PRODUCTS: lazy(() => import('../pages/components/Products')),
	PRODUCT: lazy(() => import('../pages/components/Product/Index')),
	PRODUCT_RAWS: lazy(() => import('../pages/components/Product/ProductRaws')),
	PRODUCT_SEMIPRODUCTS: lazy(() => import('../pages/components/Product/SemiProducts')),
	PRODUCT_OPERATIONS: lazy(() => import('../pages/components/Product/ProductOperations')),
	PRODUCT_GALLERY: lazy(() => import('../pages/components/Product/ProductGallery')),

	SERVICES: lazy(() => import('../pages/components/Services')),
	SERVICE: lazy(() => import('../pages/components/Service/Index')),
	SERVICE_RAWS: lazy(() => import('../pages/components/Service/ServiceRaws')),
	SERVICE_SEMIPRODUCTS: lazy(() => import('../pages/components/Service/ServiceSemiProducts')),
	SERVICE_OPERATIONS: lazy(() => import('../pages/components/Service/ServiceOperations')),
	SERVICE_GALLERY: lazy(() => import('../pages/components/Service/ServiceGallery')),

	CATEGORIES: lazy(() => import('../pages/components/Categories')),
}

const PROJECT = {
	PROJECTS: lazy(() => import('../pages/projects/Projects')),
	PROJECT_EXPENSES: lazy(() => import('../pages/projects/ProjectExpenses')),
	PROJECT: lazy(() => import('../pages/projects/Project')),
	PROJECT_TEAMS: lazy(() => import('../pages/projects/Teams')),
	PROJECT_TEAM: lazy(() => import('../pages/projects/Team')),
	PROJECT_REPORTS: lazy(() => import('../pages/projects/ProjectReports')),
	PROJECT_ARCHIVE: lazy(() => import('../pages/projects/ProjectArchive')),

	SUB_PROJECTS: lazy(() => import('../pages/projects/Project/SubProjects')),
	CASH_FLOW: lazy(() => import('../pages/projects/Project/CashFlow')),
	PROJECT_COLUMNS: lazy(() => import('../pages/projects/Project/Columns')),
	PROJECT_FILES: lazy(() => import('../pages/projects/Project/Files')),
	PROJECT_INPUTS: lazy(() => import('../pages/projects/Project/Inputs')),
	PROJECT_OUTPUTS: lazy(() => import('../pages/projects/Project/Outputs')),
	PROJECT_GANTT: lazy(() => import('../pages/projects/Project/Gantt')),
	PROJECT_FLOW: lazy(() => import('../pages/projects/Project/Flow')),
}

const PRODUCTION = {
	PLANNED: lazy(() => import('../pages/production/Planned')),
	REPORTS: lazy(() => import('../pages/production/Reports')),
	ARCIVE: lazy(() => import('../pages/production/Archive')),
	PRODUCTION: lazy(() => import('../pages/production/Production')),
	RECORDS: lazy(() => import('../pages/production/OperationRecords')),

}

const MARKETING = {
	OFFERS: lazy(() => import('../pages/marketing/Offers')),
	OFFER: lazy(() => import('../pages/marketing/Offer')),

	SALES: lazy(() => import('../pages/marketing/Sales')),
	SALE: lazy(() => import('../pages/marketing/Sale')),

	AUDIENCES: lazy(() => import('../pages/marketing/Audiences')),
	AUDIENCE: lazy(() => import('../pages/marketing/Audience')),

	CUSTOMERS: lazy(() => import('../pages/marketing/Customers')),
	CUSTOMER: lazy(() => import('../pages/marketing/Customer')),

	PRICINGSEGMENTS: lazy(() => import('../pages/marketing/PriceSegments')),
	CURRENTPRICING: lazy(() => import('../pages/marketing/CurrentPricing')),

}

const HR = {
	EMPTYPOSITIONS: lazy(() => import('../pages/hr/hiring/EmptyPositions')),
	HIRINGPROCESSES: lazy(() => import('../pages/hr/hiring/HiringProcesses')),
	PROCESS: lazy(() => import('../pages/hr/hiring/Process.js/index')),
	HIRING_COLUMNS: lazy(() => import('../pages/hr/hiring/Process.js/Columns')),
	HIRING_FILES: lazy(() => import('../pages/hr/hiring/Process.js/Files')),

	CVSOURCE: lazy(() => import('../pages/hr/hiring/CVS')),
	CV: lazy(() => import('../pages/hr/hiring/CV')),

	HRPOSITIONS: lazy(() => import('../pages/hr/staff/Positions')),
	STAFFLIST: lazy(() => import('../pages/hr/staff/StaffList')),
	SALARIES: lazy(() => import('../pages/hr/staff/Salaries')),
	LEAVES: lazy(() => import('../pages/hr/staff/Leaves')),

	PERFORMANCES: lazy(() => import('../pages/hr/improves/Performances')),
	STAFFRELATIONS: lazy(() => import('../pages/hr/improves/StaffRelations')),
	COMPENSATIONS: lazy(() => import('../pages/hr/improves/Compensations')),
	DISMISSALS: lazy(() => import('../pages/hr/improves/Dismissals')),
}

const PURCHASE = {
	DEMANDS: lazy(() => import('../pages/purchase/PurchaseDemands')),
	PROCESSES: lazy(() => import('../pages/purchase/PurchaseProcesses')),
	PURCHASE: lazy(() => import('../pages/purchase/Purchase/index')),
	PURCHASE_COLUMNS: lazy(() => import('../pages/purchase/Purchase/Columns')),
	INPUTS: lazy(() => import('../pages/purchase/Purchase/Inputs')),
	PLANNEDPROCESS: lazy(() => import('../pages/purchase/Purchase/Planned')),
	FILES: lazy(() => import('../pages/purchase/Purchase/Files')),

	PLANNEDPURCHASES: lazy(() => import('../pages/purchase/PlannedPurchases')),
	PLANNEDPURCHASE: lazy(() => import('../pages/purchase/PlannedPurchase')),

	AGGREEMENTS: lazy(() => import('../pages/purchase/Aggreements')),
	SHIPPNGS: lazy(() => import('../pages/purchase/Waybills')),
	COSTCONTROL: lazy(() => import('../pages/purchase/CostControl')),
	POLICIES: lazy(() => import('../pages/purchase/Policies')),
	STOCK: lazy(() => import('../pages/purchase/Stock')),
	PARTNERS: lazy(() => import('../pages/purchase/Partners')),
}

const MYPAGES = {
	DEPARTMENT: lazy(() => import('../pages/myPages/Department')),
	PROJECTS: lazy(() => import('../pages/myPages/Projects')),
	PRODUCTIONS: lazy(() => import('../pages/myPages/Productions')),
	TASKS: lazy(() => import('../pages/myPages/Tasks')),
}

const STOCK = {
	RAW: lazy(() => import('../pages/stock/Raws')),
	PRODCUT: lazy(() => import('../pages/stock/Products')),
	WAYBILLS: lazy(() => import('../pages/stock/Waybills2')),
	WAYBILL: lazy(() => import('../pages/stock/WayBill')),
}

const MAIN_PAGES = {
	MANAGER: lazy(() => import('../pages/presentation/mainpages/Manager')),
}

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const presentation = [
	/**
	 * Landing
	 */
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},
	{
		path: "/profil",
		element: <Profile />,
	},
	/** ************************************************** */

	/**
			* Main Pages
	  */

	{
		path: "/dashboard/management-detail",
		element: <MAIN_PAGES.MANAGER />,
	},

	/** ************************************************** */

	/**
		* Finance
  */
	{
		path: `${financeReportPageMenues.monthlyBalance.subMenu.general.path}`,
		element: <FINANCE.GENERAL />,
	},
	{
		path: `${financeReportPageMenues.monthlyBalance.subMenu.income.path}`,
		element: <FINANCE.INCOME />,
	},
	{
		path: `${financeReportPageMenues.monthlyBalance.subMenu.outcome.path}`,
		element: <FINANCE.OUTCOME />,
	},
	{
		path: `${financeReportPageMenues.accounts.subMenu.accounts.path}`,
		element: <FINANCE.ACCOUNTS />,
	},
	{
		path: `${financeReportPageMenues.accounts.subMenu.transactions.path}`,
		element: <FINANCE.TRANSACTIONS />,
	},

	/**
			* Company
	  */
	{
		path: companyPagesMenu.people.subMenu.positions.path,
		element: <COMPANY.POSITIONS />,
	},
	{
		path: companyPagesMenu.people.subMenu.users.path,
		element: <COMPANY.USERS />,
	},
	{
		path: companyPagesMenu.departments.path,
		element: <COMPANY.DEPARTMENTS />,
	},
	{
		path: companyPagesMenu.people.subMenu.people.path,
		element: <COMPANY.PEOPLE />,
	},
	{
		path: `${companyPagesMenu.people.subMenu.people.path}/person-detail`,
		element: <COMPANY.PERSON />,
	},
	{
		path: `${companyPagesMenu.people.subMenu.users.path}/user-detail`,
		element: <COMPANY.USER />,
	},
	{
		path: `${companyPagesMenu.company.path}`,
		element: <COMPANY.DETAILS />,
	},
	/** ************************************************** */

	/**
		* Component
	*/
	{
		path: componentPagesMenu.componentUnits.path,
		element: <COMPONENT.MEASURES />,
	},
	{
		path: componentPagesMenu.componentDepartments.path,
		element: <COMPONENT.DEPARTMENTS />,
	},
	{
		path: pageMenues.department.subMenu.general.path,
		element: <COMPONENT.DEPARTMENT />,
	},
	{
		path: pageMenues.department.subMenu.subUnits.path,
		element: <COMPONENT.DEPARTMENT_SUBUNITS />,
	},
	{
		path: pageMenues.department.subMenu.people.path,
		element: <COMPONENT.DEPARTMENT_PEOPLE />,
	},
	{
		path: pageMenues.department.subMenu.operations.path,
		element: <COMPONENT.DEPARTMENT_OPERATIONS />,
	},
	{
		path: pageMenues.department.subMenu.gallery.path,
		element: <COMPONENT.DEPARTMENT_GALLERY />,
	},
	{
		path: pageMenues.department.subMenu.tutorial.path,
		element: <COMPONENT.DEPARTMENT_TUTORIAL />,
	},
	{
		path: componentPagesMenu.components.subMenu.componentRawMaterials.path,
		element: <COMPONENT.RAWS />,
	},
	{
		path: `${componentPagesMenu.components.subMenu.componentRawMaterials.path}/raw-detail`,
		element: <COMPONENT.RAW />,
	},
	{
		path: componentPagesMenu.components.subMenu.componentOperation.path,
		element: <COMPONENT.OPERATIONS />,
	},
	{
		path: `${componentPagesMenu.components.subMenu.componentOperation.path}/operation-detail`,
		element: <COMPONENT.OPERATION />,
	},

	{
		path: purchasingPagesMenu.purchaseCompanies.path,
		element: <COMPONENT.PARTNERS />,
	},
	{
		path: `${purchasingPagesMenu.purchaseCompanies.path}/partner-detail`,
		element: <COMPONENT.PARTNER />,
	},
	{
		path: componentPagesMenu.components.subMenu.componentProduct.path,
		element: <COMPONENT.PRODUCTS />,
	},
	{
		path: pageMenues.product.subMenu.general.path,
		element: <COMPONENT.PRODUCT />,
	},
	{
		path: pageMenues.product.subMenu.productRaws.path,
		element: <COMPONENT.PRODUCT_RAWS />,
	},
	{
		path: pageMenues.product.subMenu.semiProducts.path,
		element: <COMPONENT.PRODUCT_SEMIPRODUCTS />,
	},
	{
		path: pageMenues.product.subMenu.productOperations.path,
		element: <COMPONENT.PRODUCT_OPERATIONS />,
	},
	{
		path: pageMenues.product.subMenu.gallery.path,
		element: <COMPONENT.PRODUCT_GALLERY />,
	},
	{
		path: componentPagesMenu.components.subMenu.componentService.path,
		element: <COMPONENT.SERVICES />,
	},
	{
		path: pageMenues.service.subMenu.general.path,
		element: <COMPONENT.SERVICE />,
	},
	{
		path: pageMenues.service.subMenu.productRaws.path,
		element: <COMPONENT.SERVICE_RAWS />,
	},
	{
		path: pageMenues.service.subMenu.semiProducts.path,
		element: <COMPONENT.SERVICE_SEMIPRODUCTS />,
	},
	{
		path: pageMenues.service.subMenu.productOperations.path,
		element: <COMPONENT.SERVICE_OPERATIONS />,
	},
	{
		path: pageMenues.service.subMenu.gallery.path,
		element: <COMPONENT.SERVICE_GALLERY />,
	},
	{
		path: "/definitions/categories",
		element: <COMPONENT.CATEGORIES />,
	},
	/** ************************************************** */

	/**
		* Human Resources
	*/

	{
		path: hrPagesMenu.hrPositions.subMenu.hrPositions.path,
		element: <HR.EMPTYPOSITIONS />,
	},
	{
		path: hrPagesMenu.hrPositions.subMenu.hrPeriods.path,
		element: <HR.HIRINGPROCESSES />,
	},

	{
		path: hrProcessPagesMenu.general.path,
		element: <HR.PROCESS />,
	},
	{
		path: hrProcessPagesMenu.columns.path,
		element: <HR.HIRING_COLUMNS />,
	},
	{
		path: hrProcessPagesMenu.files.path,
		element: <HR.HIRING_FILES />,
	},

	{
		path: hrPagesMenu.hrPositions.subMenu.hrSource.path,
		element: <HR.CVSOURCE />,
	},

	{
		path: hrPagesMenu.hrPositions.subMenu.hrSource.path + "/cv-detail",
		element: <HR.CV />,
	},

	{
		path: hrPagesMenu.hrEmployee.subMenu.hrPositions.path,
		element: <HR.HRPOSITIONS />,
	},
	{
		path: hrPagesMenu.hrEmployee.subMenu.list.path,
		element: <HR.STAFFLIST />,
	},
	{
		path: hrPagesMenu.hrEmployee.subMenu.annualLeave.path,
		element: <HR.LEAVES />,
	},
	{
		path: hrPagesMenu.hrEmployee.subMenu.salary.path,
		element: <HR.SALARIES />,
	},

	{
		path: hrPagesMenu.hrImprovement.subMenu.hrPerformance.path,
		element: <HR.PERFORMANCES />,
	},
	{
		path: hrPagesMenu.hrImprovement.subMenu.hrEmployeeRelations.path,
		element: <HR.STAFFRELATIONS />,
	},
	{
		path: hrPagesMenu.hrImprovement.subMenu.hrOff.path,
		element: <HR.DISMISSALS />,
	},
	{
		path: hrPagesMenu.hrImprovement.subMenu.hrPrice.path,
		element: <HR.COMPENSATIONS />,
	},

	/** ************************************************** */

	/**
			* MyPAGES
	  */

	{
		path: myPages.department.path,
		element: <MYPAGES.DEPARTMENT />,
	},

	{
		path: myPages.production.path,
		element: <MYPAGES.PRODUCTIONS />,
	},
	{
		path: myPages.projects.path,
		element: <MYPAGES.PROJECTS />,
	},
	{
		path: myPages.tasks.path,
		element: <MYPAGES.TASKS />,
	},
	/** ************************************************** */

	/**
			* Marketing
	  */
	{
		path: marketingPagesMenu.marketingOffers.path,
		element: <MARKETING.OFFERS />,
	},
	{
		path: `${marketingPagesMenu.marketingOffers.path}/offer-detail`,
		element: <MARKETING.OFFER />,
	},
	{
		path: marketingPagesMenu.marketingSales.path,
		element: <MARKETING.SALES />,
	},
	{
		path: `${marketingPagesMenu.marketingSales.path}/sales-detail`,
		element: <MARKETING.SALE />,
	},
	{
		path: marketingPagesMenu.marketingAudience.subMenu.audienceCategories.path,
		element: <MARKETING.AUDIENCES />,
	},
	{
		path: `${marketingPagesMenu.marketingAudience.subMenu.audienceCategories.path}/audience-category-detail`,
		element: <MARKETING.AUDIENCE />,
	},
	{
		path: marketingPagesMenu.marketingAudience.subMenu.audienceGropus.path,
		element: <MARKETING.CUSTOMERS />,
	},
	{
		path: `${marketingPagesMenu.marketingAudience.subMenu.audienceGropus.path}/audience-detail`,
		element: <MARKETING.CUSTOMER />,
	},
	{
		path: `${marketingPagesMenu.marketingPricing.subMenu.pricingComponents.path}`,
		element: <MARKETING.PRICINGSEGMENTS />,
	},
	{
		path: `${marketingPagesMenu.marketingPricing.subMenu.actualPricing.path}`,
		element: <MARKETING.CURRENTPRICING />,
	},
	/** ************************************************** */

	/**
		* Purchase
	*/

	// {
	// 	path: purchasingPagesMenu.purchasingDemands.subMenu.purchaseDemands.path,
	// 	element: <PURCHASE.DEMANDS />,
	// },
	{
		path: purchasingPagesMenu.purchasingDemands.subMenu.purchasingPeriods.path,
		element: <PURCHASE.PROCESSES />,
	},
	{
		path: `${purchasingPagesMenu.purchasingDemands.subMenu.purchasingPeriods.path}/process-detail`,
		element: <PURCHASE.PURCHASE />,
	},
	{
		path: purchasePagesMenu.columns.path,
		element: <PURCHASE.PURCHASE_COLUMNS />,
	},
	{
		path: purchasePagesMenu.inputs.path,
		element: <PURCHASE.INPUTS />,
	},
	{
		path: purchasePagesMenu.files.path,
		element: <PURCHASE.FILES />,
	},
	{
		path: purchasePagesMenu.planned.path,
		element: <PURCHASE.PLANNEDPROCESS />,
	},

	{
		path: `${purchasingPagesMenu.purchasingDemands.subMenu.purchasePlans.path}/planned-purchase`,
		element: <PURCHASE.PLANNEDPURCHASE />,
	},
	{
		path: purchasingPagesMenu.purchasingDemands.subMenu.purchasePlans.path,
		element: <PURCHASE.PLANNEDPURCHASES />,
	},
	{
		path: purchasingPagesMenu.purchasingDemands.subMenu.purchaseAgreement.path,
		element: <PURCHASE.AGGREEMENTS />,
	},
	{
		path: purchasingPagesMenu.purchasingDemands.subMenu.purchaseWaybills.path,
		element: <PURCHASE.SHIPPNGS />,
	},
	{
		path: purchasingPagesMenu.purchasePriceControl.path,
		element: <PURCHASE.COSTCONTROL />,
	},
	// {
	// 	path: purchasingPagesMenu.purchaseImprovements.subMenu.purchasePolicies.path,
	// 	element: <PURCHASE.POLICIES />,
	// },
	// {
	// 	path: purchasingPagesMenu.purchaseImprovements.subMenu.purchaseStockRow.path,
	// 	element: <PURCHASE.STOCK />,
	// },
	// {
	// 	path: purchasingPagesMenu.purchaseImprovements.subMenu.purchaseNet.path,
	// 	element: <PURCHASE.PARTNERS />,
	// },
	/** ************************************************** */


	/**
			* Projects
	  */

	{
		path: productionPagesMenu.projects.subMenu.allProjects.path,
		element: <PROJECT.PROJECTS />,
	},
	{
		path: productionPagesMenu.projects.subMenu.projectExpenses.path,
		element: <PROJECT.PROJECT_EXPENSES />,
	},
	{
		path: productionPagesMenu.projects.subMenu.activeProjects.path,
		element: <MYPAGES.PROJECTS />,
	},
	{
		path: `${productionPagesMenu.projects.subMenu.activeProjects.path}/project-detail`,
		element: <PROJECT.PROJECT />,
	},

	{
		path: `${productionPagesMenu.projects.subMenu.allProjects.path}/project-detail`,
		element: <PROJECT.PROJECT />,
	},

	{
		path: projectPagesMenu.columns.path,
		element: <PROJECT.PROJECT_COLUMNS />,
	},
	{
		path: projectPagesMenu.files.path,
		element: <PROJECT.PROJECT_FILES />,
	},
	{
		path: projectPagesMenu.inputs.path,
		element: <PROJECT.PROJECT_INPUTS />,
	},
	{
		path: projectPagesMenu.outputs.path,
		element: <PROJECT.PROJECT_OUTPUTS />,
	},
	{
		path: projectPagesMenu.gantt.path,
		element: <PROJECT.PROJECT_GANTT />,
	},
	{
		path: projectPagesMenu.flow.path,
		element: <PROJECT.PROJECT_FLOW />,
	},
	{
		path: projectPagesMenu.cashFlow.path,
		element: <PROJECT.CASH_FLOW />,
	},
	{
		path: projectPagesMenu.subProjects.path,
		element: <PROJECT.SUB_PROJECTS />,
	},
	{
		path: subProjectPagesMenu.cashFlow.path,
		element: <PROJECT.CASH_FLOW />,
	},
	{
		path: subProjectPagesMenu.columns.path,
		element: <PROJECT.PROJECT_COLUMNS />,
	},
	{
		path: subProjectPagesMenu.files.path,
		element: <PROJECT.PROJECT_FILES />,
	},
	{
		path: subProjectPagesMenu.inputs.path,
		element: <PROJECT.PROJECT_INPUTS />,
	},
	{
		path: subProjectPagesMenu.outputs.path,
		element: <PROJECT.PROJECT_OUTPUTS />,
	},
	{
		path: subProjectPagesMenu.gantt.path,
		element: <PROJECT.PROJECT_GANTT />,
	},
	{
		path: subProjectPagesMenu.flow.path,
		element: <PROJECT.PROJECT_FLOW />,
	},

	// {
	// 	path: `${productionPagesMenu.projectTeams.path}/takim-detay`,
	// 	element: <PROJECT.PROJECT_TEAM />,
	// },
	// {
	// 	path: productionPagesMenu.projectTeams.path,
	// 	element: <PROJECT.PROJECT_TEAMS />,
	// },
	{
		path: productionPagesMenu.projects.subMenu.projectArchive.path,
		element: <PROJECT.PROJECT_ARCHIVE />,
	},
	{
		path: productionPagesMenu.projects.subMenu.projectReports.path,
		element: <PROJECT.PROJECT_REPORTS />,
	},

	/** ************************************************** */

	/**
	* Production
	*/

	{
		path: productionPagesMenu.allRecords.path,
		element: <PRODUCTION.RECORDS />,
	},
	{
		path: productionPagesMenu.productionRecords.path,
		element: <MYPAGES.TASKS />,
	},
	{
		path: productionPagesMenu.production.subMenu.productionWorkPlanned.path,
		element: <MYPAGES.PRODUCTIONS />,
	},
	{
		path: productionPagesMenu.production.subMenu.allProductionWorkPlanned.path,
		element: <PRODUCTION.PLANNED />,
	},
	{
		path: productionPagesMenu.production.subMenu.productionReports.path,
		element: <PRODUCTION.REPORTS />,
	},
	{
		path: productionPagesMenu.production.subMenu.productionArchive.path,
		element: <PRODUCTION.ARCIVE />,
	},
	{
		path: `${productionPagesMenu.production.subMenu.productionWorkPlanned.path}/production-detail`,
		element: <PRODUCTION.PRODUCTION />,
	},

	/** ************************************************** */

	/**
	* Stock
	*/
	{
		path: productionPagesMenu.stock.subMenu.stockWaybills.path,
		element: <STOCK.WAYBILLS />,
	},
	{
		path: `${productionPagesMenu.stock.subMenu.stockWaybills.path}/waybill-detail`,
		element: <STOCK.WAYBILL />,
	},
	{
		path: productionPagesMenu.stock.subMenu.stockRaw.path,
		element: <STOCK.RAW />,
	},
	{
		path: productionPagesMenu.stock.subMenu.stockProduct.path,
		element: <STOCK.PRODCUT />,
	},

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */
	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];
const contents = [...presentation];

export default contents;
